import {
  IPostBackgroundCheckParams,
  IBackgroundCheck,
} from '../../models/BackgroundChecks'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'
import { IPayload } from '../../models/Global'

export class BackgroundChecksApi {
  constructor(private axios: AxiosService) {}

  postBackgroundCheck = async (params?: IPostBackgroundCheckParams) => {
    const response = await this.axios.post<IPayload<IBackgroundCheck>>(
      Endpoints.postBackgroundCheck,
      params,
    )
    return response
  }
}
